'use client'

import { TextEntry } from '@repo/ui/TextEntry'
import { isValidNI } from '@repo/validation/isValidNI'

export type NINumberFieldProps = {
  value: string
  onChange: (value: string) => void
  label?: string
  required?: boolean
  disabled?: boolean
  sx?: Record<string, unknown>
}

const FIELD_NAME = 'nationalInsuranceNumber'
const INVALID_MESSAGE = 'Enter a valid National Insurance number'

export const NINumberField = ({
  value,
  onChange,
  label = 'National Insurance number',
  required = false,
  disabled = false,
  sx = {}
}: NINumberFieldProps) => {
  // HMRC NI numbers are conventionally upper-cased and carry no separators, so
  // normalise on every keystroke rather than only on submit.
  const handleChange = (newValue: string) => onChange(newValue.toUpperCase().replace(/\s+/g, ''))

  const isInvalid = value.length > 0 && !isValidNI(value)

  return (
    <div data-testid="NINumberField">
      <TextEntry
        name={FIELD_NAME}
        label={label}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        limit={9}
        errors={isInvalid ? { [FIELD_NAME]: INVALID_MESSAGE } : {}}
        showErrorInLabel={false}
        helperText={isInvalid ? INVALID_MESSAGE : ''}
        sx={sx}
      />
    </div>
  )
}
